class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      let hastrikot = this.closest(".cart-item").getAttribute("data-t");
      let trikot_no = this.closest(".cart-item").getAttribute("data-n");
      let trikot_id = this.closest(".cart-item").getAttribute("id");
      let line = this.dataset.index;

      let tids = [];
      let updateData = {};
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      if (hastrikot == "true") {
        const items = document.querySelectorAll(
          `.cart-items .cart-item[data-n='${trikot_no}']`
        );
        items.forEach((element) => {
          tids.push(element.getAttribute("data-key"));
        });

        let updates = {};

        // Set each variant ID to quantity 0
        tids.forEach((variantId) => {
          updates[variantId] = 0;
        });

        cartItems.updateTrikot(line, updates);
      } else {
        //console.log('this.dataset.index',this.dataset.index);
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (event.target.type == "radio") {
      let variant_value = event.target.value;

      const allVariant = JSON.parse(
        $(event.target)
          .parents(".product-option")
          .siblings('.item-variants[type="application/json"]')
          .html() || "[]"
      );
      const currentVariable = allVariant.filter((item) =>
        item.options.includes(variant_value)
      );

      const currentVariantId = currentVariable.length
        ? currentVariable[0].id
        : null;

      const currentVariantPrice = currentVariable.length
        ? currentVariable[0].price
        : null;

      const currentVariantComparePrice = currentVariable.length
        ? currentVariable[0].compare_at_price
        : 0;

      if (!currentVariantId) {
        console.error("Variant ID not found!");
        return;
      }

      // Parse properties JSON and convert the array into an object
      const propertiesArray = JSON.parse(
        $(event.target)
          .parents(".product-option")
          .siblings('.item-properties[type="application/json"]')
          .html() || "[]"
      );

      // Convert properties array into an object
      const propertiesObject = Object.fromEntries(propertiesArray);

      const qty = parseInt(
        $(event.target).parents(".cart-item").find(".quantity__input").val()
      );

      if (
        
        window.aico_percentage_discount &&
        window.aico_percentage_discount != 0
      ) {
        // Convert prices from cents to dollars
        let currentPrice = currentVariantPrice / 100;
        let comparePrice = currentVariantComparePrice ? currentVariantComparePrice / 100 : null;
        
        let discountPrice;
        let originalPrice = currentPrice; // Price to show as strikethrough
        
        // If compare_at_price exists, calculate discount from compare_at_price
        if(comparePrice) {
          let compareDiscountPrice = applyAicoDiscount(comparePrice);
          
          // Give customer maximum discount - use the lower price
          if(compareDiscountPrice < currentPrice) {
            // Discounted price is better for customer
            discountPrice = compareDiscountPrice;
            originalPrice = comparePrice;
            console.log('Using compare_at_price discount (better for customer):', compareDiscountPrice);
          } else {
            // Current price is better for customer
            discountPrice = currentPrice;
            originalPrice = comparePrice;
            console.log('Using current price (better for customer):', currentPrice);
          }
        } else {
          // No compare_at_price, calculate discount from current price
          discountPrice = applyAicoDiscount(currentPrice);
          originalPrice = currentPrice;
          console.log('Using current price discount:', discountPrice);
        }
        
        // Remove old price elements and their parent dd elements using vanilla JavaScript
        // const oldPriceElements = document.querySelectorAll('.cart-item__old-price');
        // oldPriceElements.forEach(element => {
        //   const parentDD = element.closest('dd');
        //   if (parentDD) {
        //     parentDD.remove();
        //   } else {
        //     element.remove();
        //   }
        // });
        console.log("propertiesObject", propertiesObject);
        if ("_price_item_discount" in propertiesObject) {
          propertiesObject._price_item_discount = discountPrice;
          console.log("Updated:", propertiesObject);
        } else {
          console.log("_price_item_discount not present");
        }
      }

      // Construct the final update object
      let items = [
        {
          id: currentVariantId,
          quantity: qty,
          properties: propertiesObject,
        },
      ];

      this.updateVariant(event.target, items);
    } else {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");

          if (sourceQty) {
            this.innerHTML = sourceQty.innerHTML;

            if (sourceQty.className) {
              this.className = sourceQty.className;
            }
            const cartWrapper = document.querySelector(".cart__wrapper");
            if (cartWrapper) {
              cartWrapper.classList.remove("is-empty");
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });

      fetch(`${routes.cart_url}?section_id=main-cart-footer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("#main-cart-footer");
          document.querySelector("#main-cart-footer").innerHTML =
            sourceQty.innerHTML;
          if (sourceQty.className) {
            document.querySelector("#main-cart-footer").className =
              sourceQty.className;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-container",
        section: document.getElementById("cart-container").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".cart__footer",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    //console.log('updateQuantity',line, quantity, name, variantId);
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (parsedState.item_count === 0) {
          $(".cart__wrapper").addClass("is-empty");
          $(".quick-add__submit").removeClass("cart_has_membership");
          $(".membership_cta").remove();
        } else {
          $(".cart__wrapper").removeClass("is-empty");
        }

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          console.log("section", section);
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateTrikot(line, updates) {
    //console.log('updateTrikot',line,updates);
    this.enableLoading(line);

    let sections = this.getSectionsToRender().map((section) => section.section);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates, sections }), // ✅ Adding sections
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (parsedState.item_count === 0) {
          $(".cart__wrapper").addClass("is-empty");
          $(".quick-add__submit").removeClass("cart_has_membership");
          $(".membership_cta").remove();
        } else {
          $(".cart__wrapper").removeClass("is-empty");
        }

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;

        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
        updateTrikotTotals();
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateVariant(line, items, properties = {}) {
    console.log("🔄 Changing Variant", line, items, properties);
    this.enableLoading(line.dataset.index);
    let that = this;
    let bodyData = { items };
    console.log("items", items);

    $.ajax({
      method: "POST",
      url: routes.cart_add_url,
      contentType: "application/json", // Explicitly set content type
      data: JSON.stringify(bodyData),
      dataType: "json",
      success: function (response) {
        let line_index = parseInt(line.dataset.index);
        let cartItemId = $(line).parents(".cart-item").data("key");
        let updates = {
          [cartItemId]: 0,
        };
        that.updateTrikot(line_index, updates);
      },
      error: function (xhr, status, error) {
        //console.error('Error:', xhr.responseText);
        const mainCartItems =
          document.getElementById("main-cart-items") ||
          document.getElementById("CartDrawer-CartItems");
        if (mainCartItems) {
          mainCartItems.classList.remove("cart__items--disabled");
        }

        const cartItemElements = document.querySelectorAll(
          `#CartItem-${line.dataset.index} .loading__spinner`
        );
        const cartDrawerItemElements = document.querySelectorAll(
          `#CartDrawer-Item-${line.dataset.index} .loading__spinner`
        );

        cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
        cartDrawerItemElements.forEach((overlay) =>
          overlay.classList.add("hidden")
        );

        let message = window.cartStrings.error;
        try {
          const response = JSON.parse(xhr.responseText);
          const errors = response.errors || response.message;

          if (typeof errors === "string") {
            message = errors;
          } else if (typeof errors === "object") {
            message = Object.values(errors).flat().join(", ");
          }
        } catch {
          message = xhr.responseText || message;
        }

        // Display the error message
        const errorBox =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errorBox) errorBox.textContent = message;
      },
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const parsedDocument = new DOMParser().parseFromString(html, "text/html");
    const newElement = parsedDocument.querySelector(selector);

    if (!newElement) {
      console.error(`❌ Selector not found in parsed HTML: ${selector}`);
      //console.log("🔍 Full parsed HTML:", parsedDocument.documentElement.outerHTML);
      return "";
    }

    return newElement.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

updateTrikotTotals();
function updateTrikotTotals() {
  console.log("Updating");
  const groupedDiscountTotals = {};
  const groupedOriginalTotals = {};

  document.querySelectorAll("tr.cart-item").forEach(row => {
    const groupKey = row.dataset.n;
    const discountPrice = parseFloat(row.dataset.discountPrice);
    const orgPrice = parseFloat(row.dataset.orgPrice);

    if (groupKey) {
      if (!isNaN(discountPrice)) {
        if (!groupedDiscountTotals[groupKey]) groupedDiscountTotals[groupKey] = 0;
        groupedDiscountTotals[groupKey] += discountPrice;
      }

      if (!isNaN(orgPrice)) {
        if (!groupedOriginalTotals[groupKey]) groupedOriginalTotals[groupKey] = 0;
        groupedOriginalTotals[groupKey] += orgPrice;
      }
    }
  });

  Object.keys(groupedDiscountTotals).forEach(n => {
    const mainItem = document.querySelector(`.main-trikot[data-n="${n}"]`);
    if (mainItem) {
      const priceWrapper = mainItem.querySelector(".cart-item__price-wrapper");

      if (priceWrapper) {
        // Update discount price
        const priceSpans = priceWrapper.querySelectorAll(".af-discount-price");
        const discountPriceEl = priceSpans[priceSpans.length - 1]; // or use .af-discount-price

        if (discountPriceEl && groupedDiscountTotals[n] > 0) {
          console.log('groupedDiscountTotalsssssssssssssss',groupedDiscountTotals[n]);
          // discountPriceEl.innerText = `DEIN PREIS: CHF ${groupedDiscountTotals[n].toFixed(2)}`;
          // discountPriceEl.innerHtml = '';
          discountPriceEl.innerHTML = `<span class="af-discount-text">DEIN PREIS:</span><span class="af-discount-price-inner">CHF ${groupedDiscountTotals[n].toFixed(2)}</span>`;
          console.log(discountPriceEl);
          discountPriceEl.classList.add('af-discount-price');

        }

        // Update strikethrough original price
        const strikPriceEl = priceWrapper.querySelector(".strik-price");

        if (strikPriceEl && groupedOriginalTotals[n] > 0) {
          strikPriceEl.innerText = `CHF ${groupedOriginalTotals[n].toFixed(2)}`;
        }

        console.log({ n, discount: groupedDiscountTotals[n], original: groupedOriginalTotals[n] });
      }
    }
  });
}